<template>
  <div class="profile">
    <header-bar></header-bar>

    <section class="profile-header" v-bind:class="{ noidea: !hasIdea }" :style="'background-image: url(' + background + ');'">
      <div class="grid-inner">
        <div class="col-6">
          <div class="image-circle">
            <img v-if="user.profileimg === 'default'" src="https://firebasestorage.googleapis.com/v0/b/pei-exchange.appspot.com/o/profile-images%2Fdefaultimg1.jpg?alt=media&token=1704a992-1ea9-4c8d-a8c5-e4c59803155f" />
          <img v-else :src="user.profileimg" />
          </div>
          <div class="info">
            <h3>{{ user.firstname + ' ' + user.surname }}</h3>
            <!-- <span class="reputation">{{ userRep['.value'] }}</span> -->
            <h4>{{ user.jobtitle }}<br/>{{ user.organisation }}</h4>
            <h4>Based in {{ user.location }}</h4>

            <router-link :to="{ name: 'Edit Profile', params: { area: 'user-meta' }}" v-if="currentUser" class="btn btn-round green">Edit Profile</router-link>
            <a v-if="!currentUser" class="btn btn-round green" @click="openChat">Chat To {{ user.firstname }}</a>

            <a v-if="!currentUser" class="btn-star" :class="{ active: isFavourited }" @click="favouriteUser"></a>

            <a v-if="!currentUser" class="btn-more" @click="openOptions"><span class="circle"></span><span class="circle"></span><span class="circle"></span></a>
          </div>
        </div>
        <div class="col-6" v-if="hasIdea">

          <h2>{{ user.bigidea }}</h2>

          <router-link :to="{ name: 'Edit Profile', params: { area: 'big-idea' }}" v-if="currentUser" class="btn btn-round green">Edit Big Idea</router-link>

          <p>Member since {{ userJoined }}</p>

        </div>
      </div>
    </section>

    <section class="profile-body">
      <div class="grid-inner">
        <div class="col-5">
          <h4 v-if="focusAreas">Focus Area:</h4>
          <!-- <router-link :to="{ name: 'Edit Profile', params: { area: 'focus-areas' }}" v-if="currentUser" class="btn btn-round green">Edit Focus Areas</router-link> -->
          <div>

            <focus-area v-for="item, key in focusAreas" :key="key" :itemid="key"></focus-area>

          </div>

          <h4 class="padding-top" v-if="countries">Regions of interest:</h4>
          <!-- <a v-if="currentUser" class="btn btn-round green margin-top">Edit Regions</a> -->
          <div>
            
            <country v-for="item, key in countries" :key="key" :itemid="key"></country>

          </div>

        </div>


        <div class="col-6 shift-1">

          <div class="skills-subsection">
            <h4 v-if="wantSkills">Skills {{ user.firstname }} is looking for:</h4>
            <!-- <a v-if="currentUser" class="btn btn-round green">Edit Skills</a> -->

            <div v-if="wantSkills" class="skills-holder">
              <div class="skills-wrapper">

                <slider :data="wantSkills"></slider>

              </div>
            </div>
          </div>

          <div class="skills-subsection">
            <h4 v-if="hasSkills">Skills {{ user.firstname }} has:</h4>
            <!-- <a v-if="currentUser" class="btn btn-round green">Edit Skills</a> -->

            <div v-if="hasSkills" class="skills-holder">

              <div class="skills-wrapper">

                <slider :data="hasSkills"></slider>

              </div>
            </div>
          </div>

        </div>


      </div>
    </section>

    <section class="profile-chat" v-if="!currentUser">
      <div class="grid-inner">
        <div class="col-4">
          <div class="chat-box" :class="{ active: chatActive }">

            <div class="header" @click="toggleChat">
              <div class="image-circle">
                <img :src="user.profileimg">
              </div>
              <h5 class="online">Chat to {{ user.firstname }}</h5>
            </div>

          
            <chat :chats="chats" :userid="this.$route.params.uid"></chat>

              <!-- <div class="message mine">
                <span class="time">6:00pm</span><span class="date">8 Mar 2017</span>
                <p class="bubble">Hi Nicolas, I noticed you're interested in networking in North Africa too.</p>
                <div class="author">
                  <span class="author-name">Nicolas Aaron</span>
                  <div class="image-circle">
                    <img src="../assets/images/test-square.jpg">
                  </div>
                </div>
              </div>

              <div class="message">
                <span class="date">8 Mar 2017</span><span class="time">6:00pm</span>
                <p class="bubble">Hi Nicolas, I noticed you're interested in networking in North Africa too.</p>
                <div class="author">
                  <div class="image-circle">
                    <img src="../assets/images/test-square.jpg">
                  </div>
                  <span class="author-name">Holly Adams</span>
                </div>
              </div> -->
            <input type="text" class="message" placeholder="Type a message..." v-model="message" v-on:keydown.enter.prevent="send"></input>
          </div>
        </div>
      </div>
    </section>

    <section class="overlay-dialogue binary" v-if="showOptionsOverlay" @click="closeOptions">
      <div class="grid-container">
        <div class="col-4 vertical-align">
          <h4>Would you like to block or report {{ user.firstname }}?</span></h4>
          <a class="btn btn-round red" @click="blockUser">Block {{ user.firstname }}</a>
          <a class="btn btn-round red" @click="blockAndReportUser">Block &amp; Report</a>
        </div>
      </div>
    </section>

    <block-report v-if="showBlockOverlay" :userid="this.$route.params.uid" :firstname="user.firstname" :surname="user.surname"></block-report>

  </div>
</template>

<script>
import { db, auth } from '@/firebase'
import HeaderBar from '@/components/HeaderBar'
import FocusArea from '@/components/profile/FocusArea'
import Skill from '@/components/profile/Skill'
import Country from '@/components/profile/Country'
import Chat from '@/components/profile/Chat'
import BlockReport from '@/components/profile/BlockReport'

import Slider from '@/components/profile/Slider'

import dateFormat from 'dateformat'

import background1 from '@/assets/images/backgrounds/1.jpg'
import background2 from '@/assets/images/backgrounds/2.jpg'
import background3 from '@/assets/images/backgrounds/3.jpg'
import background4 from '@/assets/images/backgrounds/4.jpg'
import background5 from '@/assets/images/backgrounds/5.jpg'
import background6 from '@/assets/images/backgrounds/6.jpg'
import background7 from '@/assets/images/backgrounds/7.jpg'
import background8 from '@/assets/images/backgrounds/8.jpg'
import background9 from '@/assets/images/backgrounds/9.jpg'
import background10 from '@/assets/images/backgrounds/10.jpg'
import background11 from '@/assets/images/backgrounds/11.jpg'
import background12 from '@/assets/images/backgrounds/12.jpg'

export default {
  name: 'Matches',
  props: ['thisuser', 'favourites'],
  data () {
    return {
      favourited: null,
      chatActive: false,
      message: '',
      chatID: null,
      chats: [],
      showOptionsOverlay: false,
      showBlockOverlay: false
    }
  },
  components: {
    HeaderBar,
    FocusArea,
    Skill,
    Country,
    Slider,
    Chat,
    BlockReport
  },
  computed: {
    currentUser: function () {
      if (this.$route.params.uid === this.$root.user.uid) {
        return true
      } else {
        return false
      }
    },
    background: function () {
      let random = Math.floor(Math.random() * 11) + 1
      let arr = [background1, background2, background3, background4, background5, background6, background7, background8, background9, background10, background11, background12]
      return arr[random]
    },
    userJoined: function () {
      // let joined = new Date(this.user.joined)
      let joined = dateFormat(this.user.joined, 'dS mmmm yyyy')
      return joined
    },
    hasIdea: function () {
      let bigIdea = this.user.bigidea
      if (bigIdea) {
        return true
      } else {
        return false
      }
    },
    focusAreas: function () {
      if (this.user.personality) {
        let focusAreas = this.user.personality['focus-areas']
        return focusAreas
      } else {
        return {}
      }
    },
    hasSkills: function () {
      if (this.user.personality) {
        let hasSkills = this.user.personality['have-skills']
        return hasSkills
      } else {
        return {}
      }
    },
    wantSkills: function () {
      if (this.user.personality) {
        let wantSkills = this.user.personality['want-skills']
        return wantSkills
      } else {
        return {}
      }
    },
    countries: function () {
      if (this.user.personality) {
        let countries = this.user.personality['countries']
        return countries
      } else {
        return {}
      }
    },
    isFavourited: function () {
      if (this.favourites) {
        if (this.$route.params.uid in this.favourites) {
          this.favourited = true
          return true
        }
      } else {
        this.favourited = false
        return false
      }
    }
  },
  methods: {
    favouriteUser () {
      let favData = {[this.$route.params.uid]: true}
      if (this.favourited) {
        // Remove favourite
        db.ref('users/' + this.thisuser.uid + '/favourites/' + this.$route.params.uid).remove()
      } else {
        // Add favourite
        db.ref('users/' + this.thisuser.uid + '/favourites').update(favData)
      }
    },
    toggleChat () {
      if (this.chatActive) {
        this.chatActive = false
      } else {
        this.chatActive = true
      }
    },
    openOptions () {
      this.showOptionsOverlay = true
    },
    closeOptions (e) {
      // Ignore the a tags
      if (e.target.tagName !== 'A') {
        this.showOptionsOverlay = false
      }
    },
    blockUser () {
      alert('blocked')
    },
    blockAndReportUser () {
      this.showOptionsOverlay = false
      this.showBlockOverlay = true
    },
    openChat () {
      this.chatActive = true
    },
    send () {
      if (this.message !== '') {
        var timestamp = Date.now()
        if (this.chatID) {
          db.ref('chats-messages/' + this.chatID).push({
            user: this.$root.user.uid,
            content: this.message,
            createdAt: timestamp
          })
          db.ref('users/' + this.$route.params.uid + '/unreads').set(1)
          let unreads = {[this.$route.params.uid]: 1}
          db.ref('chats/' + this.chatID).set({
            lastMessage: this.$root.profile.firstname + ': ' + this.message,
            lastUpdated: timestamp,
            unreads: unreads
          })
        } else {
          let opr = db.ref('chats').push()
          let key = opr.key
          db.ref('chats-messages/' + key).push({
            user: this.$root.user.uid,
            content: this.message,
            createdAt: timestamp
          })
          db.ref('users/' + this.$route.params.uid + '/unreads').set(1)
          let unreads = {[this.$route.params.uid]: 1}
          db.ref('chats/' + key).set({
            lastMessage: this.$root.profile.firstname + ': ' + this.message,
            lastUpdated: timestamp,
            unreads: unreads
          })
          db.ref('users-chats/' + this.$root.user.uid + '/' + key).set({
            createdAt: 0 - timestamp,
            showAfter: timestamp
          })
          db.ref('chats-members/' + key).set({
            [this.$root.user.uid]: true,
            [this.$route.params.uid]: true
          })
        }
        this.message = ''
      } else {
        alert('Please type a message.')
      }
    }
  },
  updated () {
    var container = document.querySelector('#chatter')
    container.scrollTop = container.scrollHeight
  },
  beforeCreate () {
    this.$bindAsObject('userID', db.ref('user-meta/slug').child(this.$route.params.uid))
    this.$bindAsObject('user', db.ref('users').child(this.$route.params.uid))
    this.$bindAsObject('userRep', db.ref('user-meta/reputation').child(this.$route.params.uid))
  },
  mounted () {
    let title = document.title
    let thisuser = auth.currentUser
    let thisuserid = thisuser.uid
    this.$bindAsArray('chats', db.ref('users-chats/' + thisuserid).orderByChild('createdAt'))
    title = title.replace('User Profile', this.user.firstname + ' ' + this.user.surname)
    document.title = title
  }
}
</script>




// WEBPACK FOOTER //
// UserProfile.vue?5bc9dd18